import { render, staticRenderFns } from "./DialogAddBackupContact.vue?vue&type=template&id=61746cca&scoped=true&"
import script from "./DialogAddBackupContact.vue?vue&type=script&lang=ts&"
export * from "./DialogAddBackupContact.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61746cca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
